
jQuery(function() {

    // Menu burger
    let active = false;
    $(".header__burger").on("click", function() {
        if (!active) {
            $(".header__burger, .header__menu").addClass("active");
            $(".body").addClass("lock");
            active = true;
        } else {
            $(".header__burger, .header__menu").removeClass("active");
            $(".body").removeClass("lock");
            active = false;
        }
        
    })

    // Header fade in
    let header = $(".header");

    function setHeader() {
        if($(window).width() > 767) {
            header.removeClass("fixed");
        }
        if($(window).width() <= 767) {
            if(window.pageYOffset > 200) {
                header.addClass("fixed");
            }
            if (window.pageYOffset < 200) {
                header.removeClass("fixed");
            }
        }
    }

   $(window).on("resize load scroll", setHeader);
   
    // Menu
    let aboutCoords = $(".first-screen").offset().top;
    let ingredientsCoords = $(".products").offset().top;
    let productCoords = $(".service").offset().top;
    let contactCoords = $(".footer").offset().top;

    $(".items__item").on("click", function() {
        let number = $(this).data('filter');
        if(number == 1) {
            window.scrollTo({top: aboutCoords, behavior: "smooth"})
        } else if (number == 2) {
            window.scrollTo({top: ingredientsCoords, behavior: "smooth"})
        } else if (number == 3) {
            window.scrollTo({top: productCoords, behavior: "smooth"})
        } else if (number == 4) {
            window.scrollTo({top: contactCoords, behavior: "smooth"})
        }
    })
  
    // First screen slider
    $(".first-screen__slider").slick({
        dots: false,
        arrows: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
    })

    $('.first-screen__next').on('click', function() {
        $('.first-screen__slider').slick('slickNext');
    });
    $('.first-screen__prev').on('click', function() {
        $('.first-screen__slider').slick('slickPrev');
    });

    // Service slider 
    $(".service__slider").slick({
        dots: false,
        arrows: false,
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                }
            },
        ]
    })

    $('.service__next').on('click', function() {
        $('.service__slider').slick('slickNext');
    });
    $('.service__prev').on('click', function() {
        $('.service__slider').slick('slickPrev');
    });



})


